exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".botonGuardar{\r\n\tbackground: #4db6ac;\r\n\tcolor: white;\r\n\tborder-radius: 100px;\r\n\twidth: 100px;\r\n\tmin-width: 1px;\r\n\theight: 35px;\r\n\tpadding-left: 6px;\r\n\tpadding-top: 0px;\r\n\tmargin: 2px;\r\n\tbox-shadow: 2px 5px 10px #66737f;\r\n}\r\n.botonGuardar:hover{\r\n\tbackground: white;\r\n\tcolor: #4db6ac;\r\n}\r\n.botonCancelar{\r\n\tbackground: #b61f1f;\r\n\tcolor: white;\r\n\tborder-radius: 100px;\r\n\twidth: 100px;\r\n\tmin-width: 1px;\r\n\theight: 35px;\r\n\tpadding-left: 6px;\r\n\tpadding-top: 0px;\r\n\tmargin: 2px;\r\n\tbox-shadow: 2px 5px 10px #66737f;\r\n}\r\n.botonCancelar:hover{\r\n\tbackground: white;\r\n\tcolor: #b61f1f;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/github/490/rec_ng_recibopago490v7/src/app/components/formulario/dialogo-impuesto-simple/dialogoimpsimp.component.css
// module id = ../../../../../src/app/components/formulario/dialogo-impuesto-simple/dialogoimpsimp.component.css
// module chunks = main